export default "__VITE_ASSET__Dy9wzCxg__"